
































































import {Component, Prop, Vue} from 'vue-property-decorator'
import * as _ from 'lodash';

import {DxCheckBox} from "devextreme-vue/check-box";
import UserAccessService from '@/services/user_access_service';
import { reading_column, editing_column, accept_column } from '@/constants';

export class UserAccessAggSchema  {
  id_eco_heat_node: number | null = null;
  filial: string | null = null;
  heat_node_name: string | null = null;
  permissions: any = null;
}

@Component({
  name: 'AccessGrid',
  components: {
    DxCheckBox,
  }
})
export default class extends Vue {

  @Prop() public dataSource: any;

  @Prop({default: true}) public isAdmin!: boolean;

  public service = UserAccessService;

  public reading_column = reading_column;
  public editing_column = editing_column;
  public accept_column = accept_column;

  public group_selected: any = {};

  public matrix_struct = {
    reading__main_pages: -1,
    reading__balance: -1,
    reading__cost_balance: -1,
    reading__transport: -1,
    reading__group_object_constructor: -1,
    reading__contractor: -1,
    reading__tariff: -1,
    reading__fb2__losses: -1,
    reading__fb2__usefull: -1,
    // reading__ok: -1,

    editing__group_object_constructor: -1,
    editing__contractor: -1,
    editing__tariff: -1,
    editing__rows: -1,

    editing__ok_hn__ok: -1,
    editing__ok_hn__hn: -1,
    editing__ok_hn__tp: -1,
    editing__ok_hn__kp: -1,
    editing__ok_hn__tso_p: -1,
    editing__purchase__volume: -1,
    editing__purchase__tariff: -1,
    editing__sale__volume: -1,
    editing__sale__tariff: -1,
    editing__transport_costs__volume: -1,
    editing__transport_costs__tariff: -1,
    editing__transport_income__volume: -1,
    editing__transport_income__tariff: -1,
    editing__fb02__tp: -1,
    editing__fb02__kp: -1,
    editing__fb02__tso_p: -1,
    editing__fb02__usefull: -1,

    accept__ok_hn__ok: -1,
    accept__ok_hn__hn: -1,
    accept__ok_hn__tp: -1,
    accept__ok_hn__kp: -1,
    accept__ok_hn__tso_p: -1,
    accept__purchase__volume: -1,
    accept__purchase__tariff: -1,
    accept__sale__volume: -1,
    accept__sale__tariff: -1,
    accept__transport_costs__volume: -1,
    accept__transport_costs__tariff: -1,
    accept__transport_income__volume: -1,
    accept__transport_income__tariff: -1,
    accept__fb02__tp: -1,
    accept__fb02__kp: -1,
    accept__fb02__tso_p: -1,
    accept__fb02__usefull: -1,
    accept__mailing: -1,
  };

  public columns_top: any[] = [
    {
      dataField: 'space',
      caption: 'Объект',
      rowspan: '3'
    },
    {
      dataField: 'reading',
      caption: 'Чтение',
      colspan: '9',
      rowspan: '2'
    },
    {
      dataField: 'editing',
      caption: 'Редактирование',
      colspan: '21'
    },
    {
      dataField: 'accept',
      caption: 'Акцепт',
      colspan: '18'
    },
  ];

  public columns_middle: any[] = [
    {
      dataField: 'editing__group_object_constructor',
      caption: 'Конструктор групповых объектов',
      rowspan: '2'
    },
    {
      dataField: 'editing__contractor',
      caption: 'Контрагенты',
      rowspan: '2'
    },
    {
      dataField: 'editing__tariff',
      caption: 'Цены и тарифы',
      rowspan: '2'
    },
    {
      dataField: 'editing__rows',
      caption: 'Добавление/удаление строк для заполнения',
      rowspan: '2'
    },
    {
      dataField: 'editing__ok_hn',
      caption: 'ОК/ХН/Потери',
      colspan: '5'
    },
    {
      dataField: 'editing__purchase',
      caption: 'Покупка',
      colspan: '2'
    },
    {
      dataField: 'editing__sale',
      caption: 'Реализация',
      colspan: '2'
    },
    {
      dataField: 'editing__transport_costs',
      caption: 'Транспорт, затраты',
      colspan: '2'
    },
    {
      dataField: 'editing__transport_income',
      caption: 'Транспорт, выручка',
      colspan: '2'
    },
    {
      dataField: 'fb02',
      caption: 'ФБ-02',
      colspan: '4'
    },
    {
      dataField: 'accept__ok_hn',
      caption: 'ОК/ХН/Потери',
      colspan: '5'
    },
    {
      dataField: 'accept__purchase',
      caption: 'Покупка',
      colspan: '2'
    },
    {
      dataField: 'accept__sale',
      caption: 'Реализация',
      colspan: '2'
    },
    {
      dataField: 'accept__transport_costs',
      caption: 'Транспорт, затраты',
      colspan: '2'
    },
    {
      dataField: 'accept__transport_income',
      caption: 'Транспорт, выручка',
      colspan: '2'
    },
    {
      dataField: 'accept__fb02',
      caption: 'ФБ-02',
      colspan: '4'
    },
    {
      dataField: 'accept__mailing',
      caption: 'Рассылка уведомлений',
      rowspan: '2'
    },
  ];

  public columns_low: any[] = [
    {
      dataField: 'reading__main_pages',
      caption: 'Основные страницы',
    },
    {
      dataField: 'reading__balance',
      caption: 'Физический баланс',
    },
    {
      dataField: 'reading__cost_balance',
      caption: 'Стоимостной баланс',
    },
    {
      dataField: 'reading__transport',
      caption: 'Транспорт',
    },
    {
      dataField: 'reading__group_object_constructor',
      caption: 'Конструктор групповых объектов',
    },
    {
      dataField: 'reading__contractor',
      caption: 'Контрагенты',
    },
    {
      dataField: 'reading__tariff',
      caption: 'Цены и тарифы',
    },
    {
      dataField: 'reading__fb2__losses',
      caption: 'ФБ-02. Потери',
    },
    {
      dataField: 'reading__fb2__usefull',
      caption: 'ФБ-02. Полезный отпуск',
    },

    {
      dataField: 'editing__ok_hn__ok',
      caption: 'ОК (с учетом хоз. нужд)',
    },
    {
      dataField: 'editing__ok_hn__hn',
      caption: 'Хоз. нужды',
    },
    {
      dataField: 'editing__ok_hn__tp',
      caption: 'Тех. потери',
    },
    {
      dataField: 'editing__ok_hn__kp',
      caption: 'Ком. потери',
    },
    {
      dataField: 'editing__ok_hn__tso_p',
      caption: 'Потери в смежных ТСО',
    },
    {
      dataField: 'editing__purchase__volume',
      caption: 'Объем',
    },
    {
      dataField: 'editing__purchase__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'editing__sale__volume',
      caption: 'Объем',
    },
    {
      dataField: 'editing__sale__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'editing__transport_costs__volume',
      caption: 'Объем',
    },
    {
      dataField: 'editing__transport_costs__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'editing__transport_income__volume',
      caption: 'Объем',
    },
    {
      dataField: 'editing__transport_income__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'editing__fb02__tp',
      caption: 'Тех. потери',
    },
    {
      dataField: 'editing__fb02__kp',
      caption: 'Ком. потери',
    },
    {
      dataField: 'editing__fb02__tso_p',
      caption: 'Потери в смежных ТСО',
    },
    {
      dataField: 'editing__fb02__usefull',
      caption: 'Полезный отпуск',
    },
    {
      dataField: 'accept__ok_hn__ok',
      caption: 'ОК (с учетом хоз. нужд)',
    },
    {
      dataField: 'accept__ok_hn__hn',
      caption: 'Хоз. нужды',
    },
    {
      dataField: 'accept__ok_hn__tp',
      caption: 'Тех. потери',
    },
    {
      dataField: 'accept__ok_hn__kp',
      caption: 'Ком. потери',
    },
    {
      dataField: 'accept__ok_hn__tso_p',
      caption: 'Потери в смежных ТСО',
    },
    {
      dataField: 'accept__purchase__volume',
      caption: 'Объем',
    },
    {
      dataField: 'accept__purchase__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'accept__sale__volume',
      caption: 'Объем',
    },
    {
      dataField: 'accept__sale__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'accept__transport_costs__volume',
      caption: 'Объем',
    },
    {
      dataField: 'accept__transport_costs__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'accept__transport_income__volume',
      caption: 'Объем',
    },
    {
      dataField: 'accept__transport_income__tariff',
      caption: 'Цена/Тариф',
    },
    {
      dataField: 'accept__fb02__tp',
      caption: 'Тех. потери',
    },
    {
      dataField: 'accept__fb02__kp',
      caption: 'Ком. потери',
    },
    {
      dataField: 'accept__fb02__tso_p',
      caption: 'Потери в смежных ТСО',
    },
    {
      dataField: 'accept__fb02__usefull',
      caption: 'Полезный отпуск',
    },
  ];

  created() {

  }

  isSelectedBlock(val: any) {
    return val === true;
  }

  onColumnClick(dataFiled: string) {
    if(dataFiled === 'space') return
    let set_value: boolean | null = null;
    if (this.group_selected.hasOwnProperty(dataFiled)) {
      set_value = !this.group_selected[dataFiled];
    } else {
      set_value = true;
    }
    this.group_selected[dataFiled] = set_value;

    for (let f_id of Object.keys(this.dataSource)) {
      for (let node of this.dataSource[f_id].heat_nodes) {

        const curr_value = node.permissions[dataFiled];
        let new_value: boolean | null = null;

        if (set_value === true) {
          if (curr_value === true) {
            continue

          } else {
            new_value = true;
          }

        } else {
          if (!this.isAdmin && _.isNil(node.permissions[`${dataFiled}_init`])) {
            new_value = null;
          } else {
            new_value =  false;
          }
        }
        if (dataFiled === "reading") {
          for (let col of this.reading_column) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "editing__ok_hn") {
          for (let col of this.editing_column.editing__ok_hn) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "editing__purchase") {
          for (let col of this.editing_column.editing__purchase) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "editing__sale") {
          for (let col of this.editing_column.editing__sale) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "editing__transport_costs") {
          for (let col of this.editing_column.editing__transport_costs) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "editing__transport_income") {
          for (let col of this.editing_column.editing__transport_income) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "fb02") {
          for (let col of this.editing_column.editing__fb02) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "editing") {
          this.group_selected["editing__ok_hn"] = set_value;
          this.group_selected["editing__purchase"] = set_value;
          this.group_selected["editing__sale"] = set_value;
          this.group_selected["editing__transport_costs"] = set_value;
          this.group_selected["editing__transport_income"] = set_value;
          this.group_selected["fb02"] = set_value;
          this.checkAllEdit(node, set_value, new_value);
        } else if(dataFiled === "accept__ok_hn") {
          for (let col of this.accept_column.accept__ok_hn) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "accept__purchase") {
          for (let col of this.accept_column.accept__purchase) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "accept__sale") {
          for (let col of this.accept_column.accept__sale) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "accept__transport_costs") {
          for (let col of this.accept_column.accept__transport_costs) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "accept__transport_income") {
          for (let col of this.accept_column.accept__transport_income) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "accept__fb02") {
          for (let col of this.accept_column.accept__fb02) {
            this.checkAll(col, node, set_value, new_value);
            this.$forceUpdate();
            this.service.changed = true;
          }
        } else if(dataFiled === "accept") {
          this.group_selected["accept__ok_hn"] = set_value;
          this.group_selected["accept__purchase"] = set_value;
          this.group_selected["accept__sale"] = set_value;
          this.group_selected["accept__transport_costs"] = set_value;
          this.group_selected["accept__transport_income"] = set_value;
          this.group_selected["accept__fb02"] = set_value;
          this.checkAllAccept(node, set_value, new_value);
        } else {
          node.permissions[dataFiled] = new_value;

          this.$forceUpdate();

          this.service.changed = true;

          if (this.service.changes.hasOwnProperty(node.id_eco_heat_node)) {
            this.service.changes[node.id_eco_heat_node][dataFiled] = new_value;
          } else {
            this.service.changes[node.id_eco_heat_node] = {};
            this.service.changes[node.id_eco_heat_node][dataFiled] = new_value;
          }
        }
      }
    }
  }

  onRowClick(node: any) {
    let set_value: boolean | null = null;
    if (this.group_selected.hasOwnProperty(node.id_eco_heat_node)) {
      set_value = !this.group_selected[node.id_eco_heat_node];
    } else {
      set_value = true;
    }
    this.group_selected[node.id_eco_heat_node] = set_value;

    this.selectFullRow(node, set_value);
  }

  selectFullRow(node: UserAccessAggSchema, set_value: boolean) {
    if (!node || !node.id_eco_heat_node) {
      return
    }

    for (let per of Object.keys(this.matrix_struct)) {

      const curr_value = node.permissions[per];
      let new_value: boolean | null = null;

      if (set_value === true) {
        if (curr_value === true) {
          continue

        } else {
          new_value = true;
        }

      } else {
        if (!this.isAdmin && _.isNil(node.permissions[`${per}_init`])) {
          new_value = null;
        } else {
          new_value =  false;
        }
      }

      node.permissions[per] = new_value;

      this.$forceUpdate();

      this.service.changed = true;

      if (this.service.changes.hasOwnProperty(node.id_eco_heat_node)) {
        this.service.changes[node.id_eco_heat_node][per] = new_value;
      } else {
        this.service.changes[node.id_eco_heat_node] = {};
        this.service.changes[node.id_eco_heat_node][per] = new_value;
      }
    }
  }

  onCellClick(filial_id: string, node_id: string, permission_name: string) {
    let current = this.dataSource[filial_id].heat_nodes.find((x: any) => {
      return x.id_eco_heat_node === node_id
    });

    if (!current) {
      console.error('Ошибка определения идентификатора строки');
      return
    }

    const curr_value = current.permissions[permission_name];
    let new_value: boolean | null = null;

    if (_.isNil(curr_value)) {
      new_value = true;
    }
    else if (curr_value === true) {

      if (!this.isAdmin && _.isNil(current.permissions[`${permission_name}_init`])) {
        new_value = null;
      } else {
        new_value =  false;
      }

    }
    else if (curr_value === false) {
      if (_.isNil(current.permissions[`${permission_name}_init`])) {
        new_value =  null;
      } else {
        new_value = true;
      }
    }

    current.permissions[permission_name] = new_value;

    this.$forceUpdate();

    this.service.changed = true;

    if (this.service.changes.hasOwnProperty(node_id)) {
      this.service.changes[node_id][permission_name] = new_value;
    } else {
      this.service.changes[node_id] = {};
      this.service.changes[node_id][permission_name] = new_value;
    }
  }


  private customizeCell(e: any) {
    if (e.rowType !== 'data' ||
      e.column.dataField.indexOf('blocks__') === -1) {
      return;
    }

    if (_.isNil(e.value)) {
      e.cellElement.classList.add('undefined');
      e.cellElement.innerHTML = '';
    }
    else if (e.value === true) {
      e.cellElement.classList.add('selected');
      e.cellElement.innerHTML = '';
    }
  }

  checkAll(col: string, node: any, set_value: boolean, new_value:boolean | null) {
    node.permissions[col] = new_value;
    this.group_selected[col] = set_value;
    if (this.service.changes.hasOwnProperty(node.id_eco_heat_node)) {
      this.service.changes[node.id_eco_heat_node][col] = new_value;

    } else {
      this.service.changes[node.id_eco_heat_node] = {};
      this.service.changes[node.id_eco_heat_node][col] = new_value;
    }
  }

  checkAllEdit(node: any, set_value: boolean, new_value:boolean | null) {
    for (let key in this.editing_column) {
      if (key === "editing__tariff" || key === "editing__rows" || key === "editing__contractor" || key === 'editing__group_object_constructor') {
        this.checkAll(key, node, set_value, new_value);
      } else {
        for (let col of this.editing_column[key]) {
        this.checkAll(col, node, set_value, new_value);
      }
      }
    }
    this.$forceUpdate();
    this.service.changed = true;
  }

  checkAllAccept(node: any, set_value: boolean, new_value:boolean | null) {
    for (let key in this.accept_column) {
      for (let col of this.accept_column[key]) {
        this.checkAll(col, node, set_value, new_value);
      }
    }
    this.$forceUpdate();
    this.service.changed = true;
  }
}
